module.exports = __webpack_public_path__ + "img/register-preview.910d8c15.jpg";